$(document).ready(function () {

    $('.js-hamburger').on('click', function () {
        $('.js-nav').fadeToggle();
    });

});